export const TIPS = {
    NAME: {
        ROUTES: {
            HOME_VIEW: 'home_view',
            EVENTOS_VIEW: 'eventos_view',
            EVENTO_VIEW: 'evento_view',
            ALERTAS_VIEW: 'alertas_view',
            ALERTA_VIEW: 'alerta_view',
            INCIDENCIAS_VIEW: 'incidencias_view',
            INCIDENCIA_VIEW: 'incidencia_view',
            NOT_FOUND: 'not_found',
        },
        MODALS: {
            ENTIDADES_MODAL: 'entidades_modal',
            EXPEDIENTE_MODAL_NUEVO: 'expediente_modal_nuevo',
            EXPEDIENTE_MODAL_VIEW: 'expediente_modal_view',
            LISTAS_MODAL: 'listas_modal',
            SELECCION_TASA_MODAL: 'seleccion_tasa_modal',
            SELECCION_PERSONA_MODAL: 'seleccion_persona_modal',
            SELECCION_SUB_TASA_MODAL: 'seleccion_sub_tasa_modal',
            ARCHIVO_MODAL: 'archivo_modal',
            OBSERVACION_MODAL: 'observacion_modal',
            ETIQUETA_MODAL: 'etiqueta_modal',
        }
    },
};
